<template>
    <app-data-table :items="data" :fields="fields">
        <template slot="maintenance_required" slot-scope="{ item }">{{
            item.maintenance_required | yesno
        }}</template>
        <template slot="restricted" slot-scope="{ item }">{{
            item.restricted | yesno
        }}</template>
        <template slot="actions" slot-scope="{ item }">
            <b-btn
                v-if="item.active == 1"
                variant="primary"
                size="sm"
                @click="onRegister(item)"
            >
                <i class="fa fa-plus"></i>
            </b-btn>
            <b-btn variant="primary" size="sm" @click="onView(item)">
                <i class="fa fa-search"></i>
            </b-btn>
            <b-btn
                v-if="item.active == 1"
                variant="danger"
                size="sm"
                @click="onDelete(item)"
            >
                <i class="fa fa-trash"></i>
            </b-btn>
        </template>
    </app-data-table>
</template>
<script>
export default {
    data() {
        return {
            fields: [
                {
                    key: 'name',
                    label: 'Formato',
                },
                {
                    key: 'version',
                    label: 'Versión',
                },
                {
                    key: 'code',
                    label: 'Código',
                },
                {
                    key: 'created_at',
                    label: 'Fecha creación',
                },
                {
                    key: 'actions',
                    label: 'Acciones',
                },
            ],
        }
    },
    props: {
        data: {
            type: [Object, Array],
            required: true,
        },
        onDelete: {
            type: Function,
            required: true,
        },
    },
    methods: {
        onView(item) {
            return this.$router.push({
                name: 'formatDetailList',
                params: {
                    formatId: item.id,
                    formatTitle: item.name,
                    formatCode: item.code,
                },
            })
        },
        onRegister(item) {
            return this.$router.push({
                name: 'formatRegister',
                params: { formatId: item.id, formatName: item.name },
            })
        },
    },
}
</script>
